import { createFileRoute } from "@tanstack/react-router";
import LawnMowerSubcategoryLanding from "@/pages/LawnMowerSubcategoryLanding";

export const Route = createFileRoute("/lawn-mowers/category/$slug")({
  component: LawnMowerSubcategoryLanding,
});
